var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-file-input',{ref:"fileUpload",attrs:{"hide-input":_vm.hideInputField,"rules":_vm.rules,"accept":_vm.accept,"placeholder":_vm.placeholder,"prepend-icon":"mdi-file-document-outline","label":_vm.label,"value":_vm.file},on:{"change":_vm.onUpload}})
}
var staticRenderFns = []

export { render, staticRenderFns }